<template>
  <component :is="componentToRender" />
</template>

<script setup>
// Imports
import { computed, ref, onMounted, onBeforeMount } from 'vue';

// Local Imports
import ReturnSubmitted from '@/components/pages/returns/ReturnSubmitted.vue';
import ReturnConfirmation from '@/components/pages/returns/ReturnConfirmation.vue';
import ReturnConfirmationView from '@/components/pages/returns/ReturnConfirmationView.vue';
import ReturnLessConfirmationView from '@/components/pages/returns/ReturnLessConfirmationView.vue';

//Config
import { RETURN_RESOLUTIONS } from 'config';

// Store and Composable
import { useReturnConfirmationStore } from '@/stores/returns/useReturnConfirmationStore';

const returnConfirmationStore = useReturnConfirmationStore();
// const router = useRouter();

const rma = returnConfirmationStore.returnDetails?.returnResponse?.[0]?.rmaList?.[0] || {};
const uopRedesignEnabled = ref(rma.isDcrRedesignEnabled || false);
const ssreEnabled = ref([RETURN_RESOLUTIONS.REPLACEMENT, RETURN_RESOLUTIONS.EXCHANGE].includes(rma.returnResolution));

const componentToRender = computed(() => {
  if (ssreEnabled.value) return ReturnSubmitted;
  if (returnConfirmationStore.returnDetails?.returnResponse || uopRedesignEnabled.value) return ReturnConfirmation;
  if (
    returnConfirmationStore.returnDetails?.returnDetails?.returnLessReturnEnabled &&
    returnConfirmationStore.returnDetails?.returnDetails?.rpShipments.length
  )
    return ReturnLessConfirmationView;
  if (returnConfirmationStore.returnDetails?.returnDetails) return ReturnConfirmationView;
  return undefined;
});

onBeforeMount(() => {
  if (!returnConfirmationStore.returnDetails) {
    window.location.href = '/purchases/online';
  }
});

onMounted(async () => {
  window.addEventListener('popstate', handleBrowserBackButton);
});

function handleBrowserBackButton() {
  //TODO: will enable this once ppe code get migrate
  // router.push('/purchases/online');
  window.location.href = '/purchases/online';
  window.removeEventListener('popstate', handleBrowserBackButton);
}
</script>
